import React, {useEffect, useState, useRef, useCallback} from "react";
import {Box} from "@unibuddy/patron";

import {useAssistantInitiationContext} from "../../providers/AssistantInitiationProvider";
import {ChatHeaderContent} from "./ChatHeaderContent";
import {ChatHeaderIntroContent} from "./ChatHeaderIntroContent";
import {useResizeObserver} from "../../../../hooks/useResizeObserver";
import {usePostMessage} from "../../../../hooks/usePostMessage";

export function ChatHeader() {
    const {postMessage} = usePostMessage();
    const {userHasSentMessage} = useAssistantInitiationContext();
    const [height, setHeight] = useState<number>(0);
    const [shouldAnimate, setShouldAnimate] = useState<boolean>(false);
    const prevUserHasSentMessage = useRef<boolean | null>(null);

    const onResize = useCallback((target: HTMLDivElement) => {
        setHeight(target.offsetHeight);
    }, []);

    const ref = useResizeObserver(onResize);

    const handleCloseClicked = useCallback(() => {
        postMessage("chatVisible=false");
    }, [postMessage]);

    useEffect(() => {
        if (prevUserHasSentMessage.current === false && userHasSentMessage === true) {
            setShouldAnimate(true);
        }
        prevUserHasSentMessage.current = userHasSentMessage;
    }, [userHasSentMessage]);

    return (
        <Box
            height={`${height}px`}
            minH={`${height}px`}
            maxH={`${height}px`}
            overflow="hidden"
            backgroundColor="white"
            borderColor="grey100"
            borderBottomWidth={1}
            transition={shouldAnimate ? "all 0.2s ease-in-out" : "none"}
        >
            <Box ref={ref} h="fit-content">
                {userHasSentMessage ? (
                    <ChatHeaderContent handleCloseClicked={handleCloseClicked} />
                ) : (
                    <ChatHeaderIntroContent handleCloseClicked={handleCloseClicked} />
                )}
            </Box>
        </Box>
    );
}
